import EditPostScene from './EditPostScene'
export default EditPostScene